import React, { FC } from 'react';
import styles from './ImageActions.module.scss';
import { RootState } from '../../../../../rootReducer';
import { connect } from 'react-redux';
import { AppDispatch } from '../../../../../store';
import ActionToggle from './ActionToggle';
import { prepareToggle } from './Helpers';
import {
  toggleAllUserFindingsVisibilityChanged,
  toggleMLFindingsVisibilityChanged,
  toggleOverlappingVisibilityChanged,
  toggleOverlayVisibilityChanged
} from '../../../Canvas/canvas.slice';

type Props = {
  toggleAllUserFindingsVisibility: boolean;
  toggleMLFindingsVisibility: boolean;
  toggleOverlappingVisibility: boolean;
  toggleOverlayVisibility: boolean;
  onToggleAllFindingsVisibilityChanged: (mode: boolean) => void;
  onToggleMLFindingsVisibilityChanged: (mode: boolean) => void;
  onToggleOverlappingVisibilityChanged: (mode: boolean) => void;
  onToggleOverlayVisibilityChanged: (mode: boolean) => void;
};

const ImageActions: FC<Props> = ({
  toggleAllUserFindingsVisibility,
  toggleMLFindingsVisibility,
  toggleOverlappingVisibility,
  toggleOverlayVisibility,
  onToggleAllFindingsVisibilityChanged,
  onToggleMLFindingsVisibilityChanged,
  onToggleOverlappingVisibilityChanged,
  onToggleOverlayVisibilityChanged
}) => {
  const toggles = [
    prepareToggle(toggleAllUserFindingsVisibility, onToggleAllFindingsVisibilityChanged, 'Show user findings'),
    prepareToggle(toggleMLFindingsVisibility, onToggleMLFindingsVisibilityChanged, 'Show ML findings'),
    prepareToggle(toggleOverlappingVisibility, onToggleOverlappingVisibilityChanged, 'Show overlapping'),
    prepareToggle(toggleOverlayVisibility, onToggleOverlayVisibilityChanged, 'Show overlay')
  ];

  return (
    <div className={styles.imageActionsContainer}>
      {toggles.map((toggle, index) => (
        <ActionToggle key={index} checked={toggle.checked} onClick={toggle.onClick} label={toggle.label} />
      ))}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  toggleAllUserFindingsVisibility: state.canvas.toggleAllUserFindingsVisibility,
  toggleMLFindingsVisibility: state.canvas.toggleMLFindingsVisibility,
  toggleOverlappingVisibility: state.canvas.toggleOverlappingVisibility,
  toggleOverlayVisibility: state.canvas.toggleOverlayVisibility
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  onToggleAllFindingsVisibilityChanged: (mode: boolean) => dispatch(toggleAllUserFindingsVisibilityChanged(mode)),
  onToggleMLFindingsVisibilityChanged: (mode: boolean) => dispatch(toggleMLFindingsVisibilityChanged(mode)),
  onToggleOverlappingVisibilityChanged: (mode: boolean) => dispatch(toggleOverlappingVisibilityChanged(mode)),
  onToggleOverlayVisibilityChanged: (mode: boolean) => dispatch(toggleOverlayVisibilityChanged(mode))
});

export default connect(mapStateToProps, mapDispatchToProps)(ImageActions);
